import React, { useEffect, useState } from 'react';
import cleanRichText from '../utils/cleanRichText';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { options } from './InschrijvenVoorlichting';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';
import {
  ContentContainer,
  GlobalContainer,
  NavigationContainer,
} from '../components/Container';
import {
  TwoColumnGrid,
  Column,
} from '../layouts/TwoColumnGrid';
import { InschrijvenForm } from '../components/forms';
import { client } from '../client';

const InschrijvenTrainingPage = () => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const result = await client.getEntries({
        content_type: 'inschrijvenTrainingPage',
        include: 10,
      });
      setContent(result.items[0].fields);
    };
    fetchData();
  }, []);

  return (
    <>
      {content
        && (
          <>
            <GlobalContainer>
              <NavigationContainer>
                <Navigation inverted />
              </NavigationContainer>
            </GlobalContainer>
            <GlobalContainer>
              <ContentContainer>
                <TwoColumnGrid>
                  <Column>
                    {documentToReactComponents(cleanRichText(content.beschrijving), options)}
                  </Column>
                  <Column>
                    <InschrijvenForm
                      type="training"
                      eventData={{
                        placeholder: content.formulierWaardes.fields.selectOptiesPlaceholder,
                        options: content.formulierWaardes.fields.selectOpties,
                      }}
                      firstnamePlaceholder="Voornaam"
                      surnamePlaceholder="Achternaam"
                      dateOfBirthPlaceholder="Geboortedatum"
                      emailPlaceholder="Email adres"
                      phonePlaceholder="Telefoonnummer"
                      remarksPlaceholder={content.formulierWaardes.fields.opmerkingenPlaceholder}
                      errorMessage={content.formulierWaardes.fields.foutmelding}
                      succesMessage={content.formulierWaardes.fields.succesmelding}
                      disclaimer={content.formulierWaardes.fields.disclaimer}
                      buttonLabel={content.formulierWaardes.fields.buttonTekst}
                    />
                  </Column>
                </TwoColumnGrid>
              </ContentContainer>
            </GlobalContainer>
            <Footer />
          </>
        )}
    </>
  );
};

export default InschrijvenTrainingPage;
